<script setup lang="ts">
import { useTranslation } from "i18next-vue";
import { storeToRefs } from "pinia";
import { computed, onUnmounted, watch } from "vue";
import { useMainStore } from "#/store/main";
import { useThemeStore } from "#/store/theme";
import ButtonDefault from "../buttons/default/ButtonDefault.vue";

const props = defineProps<{
	textNotificationDefault: string;
	backgroundColor: string;
	buttonAccept: any;
	type?: boolean;
	is_qr?: boolean;
}>();

const { t } = useTranslation();

const themeStore = useThemeStore();
const mainLibStore = useMainStore();
const { is18Allowed, notificationData_lib } = storeToRefs(mainLibStore);

const background = computed(() => props.backgroundColor || ("rgba(50, 50, 50, 0.9)" as string));
const is_Notification_Block = computed(() => !!themeStore.data?.kiosk_hide_menu_update_notification);

let timerNotify: ReturnType<typeof setTimeout> | undefined;

const isVisible = defineModel("visible", { default: false });

const add18PlusAccept = () => {
	if (notificationData_lib.value.fastAdd) {
		mainLibStore.addToCart(notificationData_lib.value.fastAdd);
		notificationData_lib.value.fastAdd = null;
	}
	sessionStorage.setItem("is_adult", "true");
	is18Allowed.value = true;
	isVisible.value = false;

	if (notificationData_lib.value.callback) {
		notificationData_lib.value.callback();
		notificationData_lib.value.callback = null;
	}
};

const hideNotification = () => {
	isVisible.value = false;
};

const closeNotificationTimer = () => {
	isVisible.value = false;
	clearTimeout(timerNotify);
};

watch(
	[isVisible, () => props.textNotificationDefault, is_Notification_Block],
	([newVal, newText, newBlock], [oldVal, oldText]) => {
		if (timerNotify && (!newVal || newVal !== oldVal || newText !== oldText)) clearTimeout(timerNotify);
		if (newBlock && newVal) timerNotify = setTimeout(closeNotificationTimer, 4000);
	},
	{ immediate: true },
);

onUnmounted(() => {
	if (timerNotify) closeNotificationTimer();
});
</script>

<template>
	<Transition v-if="!is_Notification_Block && isVisible" name="notificationBlack" appear>
		<div class="notification_background_black" @click="hideNotification"></div>
	</Transition>
	<Transition name="notification">
		<div class="notification_overlay" @click="hideNotification" v-if="isVisible">
			<div
				class="notification_wrapper"
				:style="{
            'background-color': background,
            border: `2px solid ${background}`
          }"
			>
				<div class="notification_info">
					<div class="notification_18plus" v-if="type">
						<div class="notification_18plus_image">
							<img :src="themeStore.data?.adult_disclaimer_image || themeStore.data?.fallback_image || ''" alt="disclamer">
						</div>
						<div class="notification_18plus_text">{{ themeStore.data?.adult_disclaimer_text }}</div>
						<div class="notification_18plus_accept">
							<label for="plus18">{{ t(`adult.description`) }} </label>
							<ButtonDefault
								:textButtonDefault="t(`adult.button.submit`)"
								:onClick="add18PlusAccept"
								:style="{ fontSize: 'calc(1rem * var(--fontFit-x, 1))', padding: '6px 24px', marginLeft: '10px' }"
							/>
						</div>
					</div>
					<div class="notification_text" v-else>
						{{ textNotificationDefault }}
						<div class="wrapper_button_accept" v-if="buttonAccept?.state">
							<ButtonDefault class="button_accept" :textButtonDefault="buttonAccept.text" :onClick="buttonAccept.acceptBtn" :disabled="buttonAccept.disabled" />
						</div>
					</div>
				</div>
			</div>
		</div>
	</Transition>
</template>

<style lang="scss">
  @use "./notificationWindow.scss";
  </style>
